<!-- discover-mobile-01 preview — Google Discover feed video ad -->
<app-mobile-frame>
  <app-discover-mobile-header frameTop></app-discover-mobile-header>

  <!-- START: Discover feed -->
  <div class="gd-feed">
    <!-- START: Real ad -->
    <div class="gd-card">
      <div class="gd-advertiser d-flex flex-row align-items-center gap-2">
        <img class="gd-advertiser-logo" src="assets/images/valamar_logo_80x80.jpg" alt="" />
        <div class="gd-advertiser-text">
          <div class="gd-advertiser-name">Valamar</div>
          <div class="gd-sponsored">Sponsored</div>
        </div>
        <i class="bi bi-info-circle gd-v-info ms-auto"></i>
      </div>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gd-creative-link">
        <img *ngIf="thumbnailUrl; else noCreative" class="gd-v-creative" [src]="thumbnailUrl" alt="" />

        <ng-template #noCreative>
          <div class="gd-v-creative creative-missing">
            <ng-container *ngIf="isResolving; else askForVideo">
              Reading video formats&hellip;
            </ng-container>
            <ng-template #askForVideo>
              Add a {{ format }} video to see this preview
            </ng-template>
          </div>
        </ng-template>

        <!-- Player chrome, only drawn over a creative — it is unreadable on the
             grey empty slot. -->
        <ng-container *ngIf="thumbnailUrl">
          <span class="gd-v-play d-flex align-items-center justify-content-center">
            <i class="bi bi-play-fill"></i>
          </span>
          <span class="gd-v-elapsed">00:00</span>
        </ng-container>
      </a>

      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="gd-text">
        {{ headline }}
        {{ data.descriptions[0] || "Your description appears here" }}
      </a>

      <div class="gd-actions d-flex flex-row align-items-center justify-content-end">
        <i class="bi bi-heart"></i>
        <i class="bi bi-box-arrow-up"></i>
        <i class="bi bi-three-dots-vertical"></i>
      </div>
    </div>
    <!-- END: Real ad -->
  </div>
  <!-- END: Discover feed -->
</app-mobile-frame>
